// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Document from "../../../grpc/Document.js";
import * as Buhta_cabinet__DummyTable from "../../molecules/Table/DummyTable.js";
import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_cabinet__Org from "../../../models/Org.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ManageContractors(Props) {
  let org = Props.org;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const match$1 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__Document.ContractorService.grid, undefined);
  const dispatch = match$1[1];
  const grid = match$1[0];
  React.useEffect((function () {
          Curry._3(dispatch, undefined, {
                search: undefined,
                page: 1,
                filters: /* [] */0,
                expand: {
                  hd: "default_bank_account",
                  tl: /* [] */0
                }
              }, undefined);
        }), []);
  return JsxRuntime.jsx("div", {
              children: typeof grid === "string" ? (
                  grid === "Loading" ? JsxRuntime.jsx(Buhta_cabinet__DummyTable.make, {}) : null
                ) : (
                  grid.NAME === "Data" ? JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                  className: "pl-6 py-3 border-b border-gray-main bg-gray-pale text-gray-medium",
                                  children: "Название"
                                }),
                            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                  className: "py-3 border-b border-gray-main bg-gray-pale text-gray-medium",
                                  children: "Тип"
                                }),
                            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                  className: "py-3 border-b border-gray-main bg-gray-pale text-gray-medium",
                                  children: "Реквизиты"
                                }),
                            Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, contractor) {
                                        const bankAccount = contractor.default_bank_account;
                                        const Key = String(i);
                                        return JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
                                                    route: contextRoute({
                                                          TAG: /* Manage */7,
                                                          _0: /* Contractors */{
                                                            _0: {
                                                              TAG: /* View */0,
                                                              _0: contractor.id
                                                            }
                                                          }
                                                        }),
                                                    className: "contents",
                                                    children: [
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "pl-6 py-2.5 border-b border-gray-main",
                                                            children: contractor.name
                                                          }),
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "py-2.5 border-b border-gray-main",
                                                            children: Buhta_cabinet__Org.Type.toString(contractor["type'"])
                                                          }),
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "py-2.5 border-b border-gray-main",
                                                            children: bankAccount !== undefined ? bankAccount.iban : null
                                                          })
                                                    ]
                                                  }, Key);
                                      }), grid.VAL))
                          ],
                          className: "grid grid-cols-3"
                        }) : null
                ),
              className: "flex flex-col w-full"
            });
}

const emptyBankAccount = {
  id: "",
  iban: "",
  bank_name: "",
  bic: "",
  create_time: undefined,
  update_time: undefined
};

const make = ManageContractors;

export {
  emptyBankAccount ,
  make ,
}
/* Buhta_cabinet__Document Not a pure module */
